<div mat-dialog-title>
	<span translate>confirm.same.material</span>
	&ngsp;
	<b *ngIf="claimedBatch" class="confirm-popup-alignment">{{claimedBatch}}</b>
	<span class="confirm-popup-alignment">.</span>
</div>

<div mat-dialog-content>
	<p>
		<span translate>confirm.modified</span>
		&ngsp;
		<b *ngIf="claimedModificationDate" class="confirm-popup-alignment">{{claimedModificationDate}}</b>
		&ngsp;
		<span class="confirm-popup-alignment" translate>confirm.respectively</span>
	</p>
	<p translate>confirm.continue</p>
</div>

<div mat-dialog-actions>
	<button type="button" mat-raised-button class="dialog-button copo-dialog-button-margin" (click)="claimSubmit(true)" tabindex="-1">
		<span translate>offer.type.yes</span>
	</button>
	<button type="button" mat-raised-button (click)="claimSubmit(false)"
		class="dialog-button copo-dialog-button-margin copo-button" tabindex="-1" copoFocusMe>
		<span translate>offer.type.no</span>
	</button>
</div>